import { AppState } from "@/mk2/reducers";

import {
    ListOfForumsPageState,
    TopicsListState,
    initialListOfForumsPageState,
    initialTopicsListState,
} from "./ListOfForums.reducers";

export const getListOfForumsState = (state: AppState): ListOfForumsPageState =>
    state.containers.forum.listOfForums || initialListOfForumsPageState;

export const getListOfForumsTopicsListState = (state: AppState): TopicsListState => {
    const listOfForumsState = getListOfForumsState(state);
    return listOfForumsState.topics ? listOfForumsState.topics : initialTopicsListState;
};
